/**
 * Steering Page - Secret admin page for STEERING BRAIN monitoring
 *
 * Accessible only at /adminsteering (not linked from anywhere)
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import SteeringTab from './admin/SteeringTab';

export default function SteeringPage() {
  const { t } = useTranslation('admin');
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  // Redirect non-admin users
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    } else if (user?.role !== 'admin') {
      navigate('/voice');
    }
  }, [isAuthenticated, user, navigate]);

  if (!isAuthenticated || user?.role !== 'admin') {
    return null;
  }

  return (
    <div className="bg-gray-900" style={{ minHeight: 'calc(100vh - var(--health-banner-height, 0px))' }}>
      {/* Minimal header */}
      <div className="bg-gray-800 border-b border-gray-700 px-4 py-3">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center gap-3">
            <span className="text-purple-400 text-xl">🧠</span>
            <h1 className="text-lg font-semibold text-white">{t('steering.title')}</h1>
          </div>
          <button
            onClick={() => navigate('/voice')}
            className="text-gray-400 hover:text-white text-sm"
          >
            ← {t('common:navigation.back')}
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        <SteeringTab />
      </div>
    </div>
  );
}
